import { render, staticRenderFns } from "./HomeWrap.vue?vue&type=template&id=0787de14&"
import script from "./HomeWrap.vue?vue&type=script&lang=ts&"
export * from "./HomeWrap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports